const conversionFactors = {
    'Joules': 1,
    'Kilojoules': 1000,
    'Calories': 4.184,
    'Kilocalories': 4184,
    'Watt-hours': 3600,
    'Kilowatt-hours': 3600000,
    'Electron-volts': 1.602176634e-19,
    'British Thermal Units (BTU)': 1055.06,
    'Therms': 105506000,
    'Foot-pounds': 1.355818,
    'Ergs': 1e-7
  };
  
  export const convertEnergy = (value, fromUnit, toUnit) => {
    const valueInJoules = value * conversionFactors[fromUnit];
    return valueInJoules / conversionFactors[toUnit];
  };